import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "appliedFiltersContainer" }
const _hoisted_3 = {
  key: 0,
  class: "appliedFilters"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 1,
  class: "appliedFilters"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "border-0 py-5" }
const _hoisted_10 = { class: "d-flex align-items-start justify-content-between flex-wrap gap-3" }
const _hoisted_11 = { class: "align-items-start flex-column" }
const _hoisted_12 = { class: "fw-bolder fs-3 mb-1" }
const _hoisted_13 = { class: "d-flex align-items-center gap-3 flex-wrap" }
const _hoisted_14 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_15 = { class: "position-relative my-1" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3 svg-icon-gray-500 position-absolute top-50 translate-middle ps-10" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      opacity: "0.5",
      x: "17.0365",
      y: "15.1223",
      width: "8.15546",
      height: "2",
      rx: "1",
      transform: "rotate(45 17.0365 15.1223)",
      fill: "black"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z",
      fill: "black"
    })
  ])
], -1)
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  href: "#",
  class: "btn btn-sm btn-flex btn-light btn-active-primary fw-bolder",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end",
  "data-kt-menu-target": "#filter-dropdown"
}
const _hoisted_19 = { class: "svg-icon svg-icon-5 svg-icon-gray-500 me-1" }
const _hoisted_20 = ["data-bs-target"]
const _hoisted_21 = {
  key: 0,
  class: "py-3"
}
const _hoisted_22 = { class: "grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-5 lg:gap-7.5" }
const _hoisted_23 = { class: "boxes" }
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = { class: "box-row" }
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = { class: "box-row box-footer" }
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = { class: "box-row box-footer-actions" }
const _hoisted_30 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Dropdown1 = _resolveComponent("Dropdown1")!
  const _component_Popper = _resolveComponent("Popper")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationBar = _resolveComponent("PaginationBar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.getMapping && _ctx.getMapping.map && _ctx.getMapping.map.Components)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getMapping.map.Components, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("div", null, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(item.component), _mergeProps({ ref_for: true }, item.props), null, 16))
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAppliedFilterValues, (filter, key, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          (
        _ctx.getAppliedFilterValues[key] &&
        Object.keys(_ctx.getAppliedFilterValues[key]).length > 0 &&
        _ctx.getAppliedFilterValues[key].valueText != ''
      )
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", null, [
                  _createTextVNode(_toDisplayString(_ctx.getAppliedFilterValues[key].valueText) + " ", 1),
                  _createElementVNode("button", {
                    class: "btn btn-icon",
                    onClick: ($event: any) => (_ctx.removeFilter(key, _ctx.getAppliedFilterValues[key].clear))
                  }, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr088.svg" })
                  ], 8, _hoisted_4)
                ])
              ]))
            : (
        _ctx.getAppliedFilterValues[key] &&
        Object.keys(_ctx.getAppliedFilterValues[key]).length > 0 &&
        _ctx.getAppliedFilterValues[key].valueText == '' &&
        _ctx.getAppliedFilterValues[key].value &&
        _ctx.getAppliedFilterValues[key].value != ''
      )
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", null, [
                    (Array.isArray(_ctx.getAppliedFilterValues[key].value))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAppliedFilterValues[key]
              .value, (appliedFilter, index) => {
                            return (_openBlock(), _createElementBlock("span", { key: index }, [
                              _createTextVNode(_toDisplayString(appliedFilter) + " ", 1),
                              (_ctx.getAppliedFilterValues[key].value.length != index + 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_7, " / "))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "btn btn-icon",
                      onClick: ($event: any) => (_ctx.removeFilter(key, _ctx.getAppliedFilterValues[key].clear))
                    }, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr088.svg" })
                    ], 8, _hoisted_8)
                  ])
                ]))
              : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.widgetClasses, ""])
    }, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("h3", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.pageName), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            (_ctx.getMapping?.map && !_ctx.getMapping.map.SearchDisabled)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localSearchTerm) = $event)),
                      onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.searchKeyUp && _ctx.searchKeyUp(...args))),
                      type: "text",
                      class: "form-control form-control-sm form-control-solid w-200px ps-10",
                      name: "Search",
                      placeholder: "Search"
                    }, null, 544), [
                      [_vModelText, _ctx.localSearchTerm]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.getFiltersMapping && _ctx.getFiltersMapping.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createVNode(_component_Popper, { placement: "bottom" }, {
                    content: _withCtx(() => [
                      _createVNode(_component_Dropdown1, { routeKey: _ctx.routeKey }, null, 8, ["routeKey"])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("button", _hoisted_18, [
                        _createElementVNode("span", _hoisted_19, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen031.svg" })
                        ]),
                        _createTextVNode(" Filter ")
                      ])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.getMultipleFormEdit)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 2,
                  "data-bs-toggle": "modal",
                  "data-bs-target": '#kt_modal_new_card_' + _ctx.routeKey,
                  class: "btn btn-sm btn-primary",
                  id: "kt_toolbar_primary_button",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.multipleEditToggleModal && _ctx.multipleEditToggleModal(...args)), ["prevent"]))
                }, _toDisplayString(_ctx.getMapping.map.MultipleFormButton), 9, _hoisted_20))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      (_ctx.getMapping && _ctx.getMapping.map)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "box",
                    key: index
                  }, [
                    _createElementVNode("div", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getMapping.map.Columns, (column, columnIndex) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "box-row",
                          key: columnIndex
                        }, [
                          (
                  column.type == 'text' ||
                  column.type == 'email' ||
                  column.type == 'computed' ||
                  column.type == 'money' ||
                  column.type == 'image' ||
                  column.type == 'array' ||
                  column.type == 'date' ||
                  column.type == 'object' ||
                  column.type == 'coloredObject' ||
                  column.type == 'location'
                )
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                innerHTML: column.format ? column.format(item) : item[column.name]
                        
                              }, null, 8, _hoisted_24))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128)),
                      _createElementVNode("div", _hoisted_25, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item[_ctx.getMapping.map.InnerColumn.key], (nested, j) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "box-inner-rows",
                            key: j
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getMapping.map.InnerColumn.columns, (col, k) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: _normalizeClass(["box-inner-row", { 'green-border': nested.statusId === 1, 'red-border': nested.statusId === 2 }]),
                                innerHTML: col.format ? col.format(nested) : item[col.name],
                                key: k
                              }, null, 10, _hoisted_26))
                            }), 128))
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getMapping.map.Footer, (columnFooter, columnFooterIndex) => {
                        return (_openBlock(), _createElementBlock("div", { key: columnFooterIndex }, [
                          _createElementVNode("div", {
                            innerHTML: columnFooter.format ? columnFooter.format(item) : item[columnFooter.name]
                          }, null, 8, _hoisted_28)
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getMapping.map.FooterButtons, (columnFooter, columnFooterIndex) => {
                        return (_openBlock(), _createElementBlock("div", { key: columnFooterIndex }, [
                          (columnFooter.type === 'link' && (!columnFooter.showIf || columnFooter.showIf(item)))
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                class: _normalizeClass(["btn btn-sm", columnFooter.variant ? 'btn-' + columnFooter.variant : 'btn-light']),
                                to: _ctx.resolveFooterLink(columnFooter, item)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(columnFooter.text), 1)
                                ]),
                                _: 2
                              }, 1032, ["class", "to"]))
                            : _createCommentVNode("", true),
                          (columnFooter.type === 'button'  && (!columnFooter.showIf || columnFooter.showIf(item)))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: _normalizeClass(["btn btn-sm", columnFooter.variant ? 'btn-' + columnFooter.variant : 'btn-primary']),
                                onClick: ($event: any) => (_ctx.handleMappedButton(columnFooter.onClick, item))
                              }, _toDisplayString(columnFooter.text), 11, _hoisted_30))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.getPaginationParams)
      ? (_openBlock(), _createBlock(_component_PaginationBar, {
          key: 1,
          page: _ctx.getPaginationParams.currentPage,
          "onUpdate:page": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.getPaginationParams.currentPage) = $event)),
          total: _ctx.getPaginationParams.totalItems,
          "per-page": _ctx.getPaginationParams.paginate,
          onChange: _ctx.paginateItems
        }, null, 8, ["page", "total", "per-page", "onChange"]))
      : _createCommentVNode("", true)
  ], 64))
}